import $ from 'jquery';
import CheckoutGateway from './checkout-gateway';

class LocalCheckoutGateway extends CheckoutGateway {

    constructor(...props) {
        super(...props);
        this.maybeHideGateway();
    }

    create_stripe_elements() {
        if (!this.elements) {
            if (this.isActive()) {
                this.elements = super.create_stripe_elements();
            } else {
                return null;
            }
        }
        return this.elements;
    }

    maybeHideGateway() {
        if (!this.isActive()) {
            $(this.container).hide();
            if (this.is_gateway_selected()) {
                $('li[class*="payment_method_stripe_"]').filter(':visible').eq(0).find('[name="payment_method"]').prop('checked', true).trigger('click');
            }
        } else {
            $(this.container).show();
        }
    }

    isActive() {
        return $('#wc_stripe_local_payment_' + this.gateway_id).data('active');
    }

    updated_checkout(e, data) {
        this.create_stripe_elements();
        this.createPaymentElement();
        super.updated_checkout(e, data);
        this.maybeHideGateway();
    }
}

export default LocalCheckoutGateway;